module.exports = __webpack_public_path__ + "assets/images/project/kranji-marshes/02.jpg?v=c4c3ece6";